<template>
  <div>
    <div>
      <b-card-group>
        <b-card>
          <div class="d-flex">
            <h6>Terms and Mark Up</h6>
          </div>

          <DxDataGrid :data-source="currentRateMarkUp.Term"
                      allow-item-deleting="true"
                      height="50vh">
            <DxEditing :allow-updating="true"
                       :allow-deleting="true"
                       :allow-adding="true"
                       mode="row" />
            <DxColumn data-field="Term" />
            <DxColumn data-field="APR" />
            <DxColumn data-field="Factor" v-if="isLease" />
            <DxColumn data-field="AcceptLowerMaxRate"/>

          </DxDataGrid>
        </b-card>
        <b-card>
          <h6 class="">Special or Standard Programs</h6>
          <div >
            <DxSelectBox :items="specialStandardEnum" class="form-input "
                         display-expr="description"
                         v-model:selectedItem="currentRateMarkUp.SpecialStandard"
                         value-expr="id" />
          </div>
          <div class="mt-2">
            <h6>Affected Lenders</h6>
          </div>
          <DxTagBox :data-source="availableLenders"
                    display-expr="Name"
                    :search-enabled="true"
                    v-model:value="currentRateMarkUp.Lender"></DxTagBox>
        </b-card>

      </b-card-group>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import cSwitch from '../components/Switch'
  import { DxDataGrid, DxColumn, DxEditing, DxPaging, DxLookup } from 'devextreme-vue/data-grid'
  import DxSelectBox from 'devextreme-vue/select-box'
  import DxList from 'devextreme-vue/list'
  import { DxTagBox } from 'devextreme-vue/tag-box'

  export default {
    components: {
      loading,
      cSwitch,
      DxDataGrid,
      DxSelectBox,
      DxEditing,
      DxColumn,
      DxPaging,
      DxLookup,
      DxList,
      DxTagBox
    },
    props: {
      isLease: true,
      availableLenders: {}
    },
    created() {
     
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        RateMarkUpList: ['0.00025', '0.00050', '0.00075', '0.001', '0.00125', '0.00150', '0.00175', '0.00200'],
        APRList: ['0.25', '0.50', '0.75', '1.00', '1.25', '1.50', '1.75', '2.00', '2.25', '2.50'],

        rateMarkup: {},
        currentRateMarkUp: {},
        specialStandardEnum: [{ id: 0, description: 'Both' }, { id: 1, description: 'Special' }, { id: 2, description: 'Standard' }],
        newLender: {},
        selectedItemKeys: []

      }
    },
    methods: {
      showEditTerm() {
        this.$root.$emit('bv::toggle::collapse', 'editTerm')
      },
      getLenderString: function (item) {
        var lenders = ''
        if (item.Code != undefined) {
          item.Code.forEach(l =>
            lenders = lenders + ' ' + l.Name)
        }
        else {
          lenders = 'All Lenders'
        }
        return lenders
      },
      addTerm() {
        var newTerm = {
          Term: this.$refs.txtTerm.value,
          APR: this.$refs.txtAPR.value,
          Factor: this.$refs.txtFactor.value,
          AcceptLowerMaxRate: this.$refs.swALMR.value
        }
        if (!this.currentRateMarkUp.Term.some(x => x.Term == newTerm.Term)) {
          this.currentRateMarkUp.Term.push(newTerm)
        }
        else {
          alert("Rate markup for this term already exists.")
        }
      }
    }
  
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/RateMarkUpItem.vue